import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { Container, Row, Col } from 'react-grid-system'
import moment from 'moment-timezone'

import { LoadingBoxList } from 'components/LoadingSpinner'

import EditButton from 'components/buttons/EditButton'
import DeleteButton from 'components/buttons/DeleteButton'

import styles from './index.css'

@withRouter
export default class LeavesList extends React.Component {
  
  static propTypes = {
    loading  : PropTypes.bool,
    entities : PropTypes.arrayOf(PropTypes.object),
    onDelete : PropTypes.func,
    onEdit   : PropTypes.func
  }

  static defaultProps = {
    loading : false,
    onEdit : (id) => {},
    onDelete : (id) => {}
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Container className={styles.List}>
        <Row className={styles.Header}>
          <Col xs={5}>
            <h1>Leave Type</h1>
          </Col>
          <Col xs={2}>
            <h1>Colour</h1>
          </Col>
          <Col xs={5}>
          </Col>
        </Row>
        {
          this.props.loading && <LoadingBoxList />
        }
        {
          !this.props.loading &&
          (this.props.entities || []).map(({ id, name, color }) =>
            <Row className={styles.Row} key={id}>
              <Col xs={5}>
                {name}
              </Col>
              <Col xs={2}>
                <div style={{background: color, width: '2rem', height: '2rem'}}></div>
              </Col>
              <Col xs={5} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <DeleteButton onClick={() => this.props.onDelete(id)} />
                <EditButton onClick={() => this.props.onEdit(id)} />
              </Col>
            </Row>
          )
        }
      </Container>
    )
  }

}



// WEBPACK FOOTER //
// ./src/lists/LeavesList/index.jsx